import {Link, Stack, Typography} from "@mui/material";
import {globalMaxWidth} from "../GlobalConfigs";
import React from "react";
import BreakpointIndicator from "./BreakpointIndicator";

export function TopBar() {
    return (
        <Stack alignItems='center' sx={{
            width: 1, backgroundColor: 'background.top'
        }}>
            <BreakpointIndicator/>
            <Stack direction="row" justifyContent='space-around' spacing={4} margin={1}
                   sx={{maxWidth: globalMaxWidth, width: 1}}>
                <Typography variant='subtitle2' color='white' align='center' sx={{ml:1}}>
                    XLI Simposio Nacional de la Unión Científica Internacional de Radio
                </Typography>
                <Typography variant='subtitle2' color='white' align='center'>
                    <b> 2 al 4 de Septiembre de 2026 </b>
                </Typography>
                <Typography variant='subtitle2' color='white' align='center'>
                    <Link href="mailto:congresoursi2026@ull.edu.es" underline="hover" color='white' sx={{mr:1}}>
                        congresoursi2026@ull.edu.es
                    </Link>
                </Typography>
            </Stack>
        </Stack>
    )
}